import { useInView } from 'react-intersection-observer';

type SectionObservers<T extends string> = {
    [K in T as `${K}Ref`]: (node?: Element | null) => void;
} & {
    [K in T as `${K}InView`]: boolean;
};
export const useSectionObservers = <T extends string>(
    sectionNames: T[],
    rootMargin = '1500px'
): SectionObservers<T> => {
    const entries = sectionNames.map(name => {
        return {
            name,
            // eslint-disable-next-line react-hooks/rules-of-hooks
            hook: useInView({
                root: null,
                triggerOnce: true,
                rootMargin,
            }),
        };
    });

    const observers = entries.reduce((acc, { name, hook }) => {
        const [ref, inView] = hook;
        return {
            ...acc,
            [`${name}Ref`]: ref,
            [`${name}InView`]: inView,
        };
    }, {} as SectionObservers<T>);

    return observers;
};
